import * as React from "react";
import "@aurodesignsystem/auro-input";
import "../OtsForm/AddOTSForm.scss";
import "@aurodesignsystem/auro-select";
import "@aurodesignsystem/auro-menu";
import "@aurodesignsystem/auro-combobox";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Badge from "../Badge/Badge";
import { OtsAircraft } from "../../Models/OtsAircraft";
import dayjs from "dayjs";
import ReopenModal from "../Modal/ReopenModal";

interface EditClosedDetailsProps {
  onEditOts: OtsAircraft;
  onEditDataChange: any;
  showReopenModal: boolean;
  isValidComment: boolean;
  handleModalClose: any; 
  handleModalConfirm: any;
  handleMessage: any;
  reset: boolean;
}

export default function EditClosedModalInput(props: EditClosedDetailsProps) {
  const { onEditOts, onEditDataChange, showReopenModal, isValidComment, handleModalClose, handleModalConfirm, handleMessage } = props;
  const [otstime, setotsTime] = React.useState<Date | null>();
  const [closedTime, setClosedTime] = React.useState<Date | null>();
  const [otstimeOriginal, setotsTimeOriginal] = React.useState<Date | null>();
  const [closedTimeOriginal, setClosedTimeOriginal] =
    React.useState<Date | null>();
  const [isErrorOts, setShowErrorOts] = React.useState(false);
  const [isErrorOtsClosed, setShowErrorOtsClosed] = React.useState(false);
  const [isClosedBeforeOtsStart, setShowErrorClosedBeforeStart] =
    React.useState(false);
  const [isStartAfterClosed, setShowErrorStartAfterClosed] =
    React.useState(false);
  const [isOtsValid, SetIsOtsValid] = React.useState(false);
  const [isOtsClosedValid, SetIsOtsClosedValid] = React.useState(false);
  const DisablePostButton = true;
  const EnablePostButton = false;
  const ShowErrorMessage = true;
  const HideErrorMessage = false;
  const Valid = true;
  const Invalid = false;
  useEffect(() => {
    if(props.reset){
    setotsTime(formatTime(onEditOts.OutOfServiceDateTimeUTC));
    setotsTimeOriginal(formatTime(onEditOts.OutOfServiceDateTimeUTC));
    setClosedTime(formatTime(onEditOts.ReturnToServiceTimeUTC ?? ""));
    setClosedTimeOriginal(formatTime(onEditOts.ReturnToServiceTimeUTC ?? ""));
  }
  }, [props.reset, onEditOts]);
  useEffect(() => {
    validateForm();
  }, [
    otstime,
    closedTime,
    isOtsClosedValid,
    isOtsValid,
    closedTimeOriginal,
    otstimeOriginal,
  ]);

  const dataValidationErrorDisplay = (
    showStartAfter: boolean,
    showClosedBefore: boolean
  ) => {
    setShowErrorStartAfterClosed(showStartAfter);
    setShowErrorClosedBeforeStart(showClosedBefore);
  };

  // form is invalid to start
  // if the user chanegs the ots start date, and it is valid, form is therefore, also valid.
  const handleOtsTimeChange = (ots: Date | null) => {
    setotsTime(ots);
    if (ots == null || ots == otstimeOriginal) {
      SetIsOtsValid(Invalid);
      setShowErrorOts(true);
      dataValidationErrorDisplay(HideErrorMessage, HideErrorMessage);
    } else if (
      closedTime != null &&
      otstime != null &&
      dateIsBefore(closedTime, ots)
    ) {
      SetIsOtsValid(Invalid);
      setShowErrorOts(false);
      dataValidationErrorDisplay(ShowErrorMessage, HideErrorMessage);
    } else {
      SetIsOtsValid(Valid);
      SetIsOtsClosedValid(Valid);
      setShowErrorOts(false);
      dataValidationErrorDisplay(HideErrorMessage, HideErrorMessage);
    }
  };

  const handleInvalidOtsDate = (error: any) => {
    if (error !== null) {
      setShowErrorOts(true);
      SetIsOtsValid(Invalid);
    }
  };

  const handleOtsCloseTimeChange = (otsClose: Date | null) => {
    setClosedTime(otsClose);
    // detect a change from the original closed date and time
    if (otsClose == null || otsClose == closedTimeOriginal) {
      SetIsOtsClosedValid(Invalid);
      setShowErrorOtsClosed(true);
    } else if (otstime != null && dateIsBefore(otsClose, otstime)) {
      // closed date must be after start date
      SetIsOtsClosedValid(Invalid);
      setShowErrorOtsClosed(false);
      dataValidationErrorDisplay(HideErrorMessage, ShowErrorMessage);
    } else {
      // form is valid
      setShowErrorOtsClosed(false);
      SetIsOtsClosedValid(Valid);
      SetIsOtsValid(Valid);
      dataValidationErrorDisplay(HideErrorMessage, HideErrorMessage);
    }
  };

  const handleInvalidOtsClosedDate = (error: any) => {
    if (error !== null) {
      setShowErrorOts(true);
      SetIsOtsClosedValid(Invalid);
    }
  };

  const formatTime = (inputTime: string) => {
    const convertedTime = dayjs.utc(inputTime).local();
    return convertedTime.toDate();
  };

  const datesAreEqual = (date1: Date, date2: Date) => {
    return dayjs(date1).isSame(date2);
  };

  // indicates whether the first date is before the second date
  const dateIsBefore = (date1: Date, date2: Date) => {
    return dayjs(date1).isBefore(dayjs(date2));
  };

   
  const validateForm = () => {
    console.log(
      "Validate form - isOtsValid" +
        isOtsValid +
        "isClosedValid" +
        isOtsClosedValid
    );
    if (
      otstime != null &&
      closedTime != null &&
      otstimeOriginal != null &&
      closedTimeOriginal != null
    ) {
      if (
        datesAreEqual(otstime, otstimeOriginal) &&
        datesAreEqual(closedTime, closedTimeOriginal)
      ) {
        sendData(DisablePostButton);
      } else if (isOtsValid && isOtsClosedValid) {
        sendData(EnablePostButton);
      } else {
        sendData(DisablePostButton);
      }
    } else {
      sendData(DisablePostButton);
    }
  };

  const sendData = (isSubmitDisabled: boolean) => {
    if (isSubmitDisabled) {
      const editData = {
        isSubmitDisabled: isSubmitDisabled,
      };
      onEditDataChange(editData);
    } else {
      const editData = {
        otstime: otstime,
        closedTime: closedTime,
        isSubmitDisabled: isSubmitDisabled,
      };
      onEditDataChange(editData);
    }
  };

  return (
    <React.Fragment>
    <span>
      <div className="closed-modal-edit-list">
        <div className="closed-form-input">
          <auro-input
            data-testid="aircraft-number"
            required
            validateOnInput
            activeLabel="true"
            bordered
            disabled="true"
            onkeydown="return false"
            id="edit-aircraft"
            value={onEditOts?.AircraftRegistration}
          >
            <span className="label" slot="label">
              Aircraft #{" "}
              {onEditOts?.IsEtopsCapable === "true" ? (
                <div className="badge-edit-container">
                  <span className="badge-data create">
                    <Badge data="E" />
                  </span>
                </div>
              ) : (
                ""
              )}
            </span>
          </auro-input>
        </div>
        <div className="closed-form-input">
          <auro-input
            disabled="true"
            data-testid="station"
            required
            activeLabel="true"
            bordered
            maxlength="3"
            minLength="3"
            pattern="[a-zA-Z]{3}"
            value={onEditOts?.Station}
          >
            <span className="label" slot="label">
              Station
            </span>
          </auro-input>
        </div>
        <div className="closed-form-input">
          <auro-input
            activeLabel="true"
            disabled="true"
            bordered
            value={onEditOts?.Location}
          >
            <span className="label" slot="label">
              Loc
            </span>
          </auro-input>
        </div>

        <div className="closed-form-input">
          <auro-input activeLabel="true" disabled="true" bordered value="N/A">
            <span className="label" slot="label">
              ADV Time
            </span>
          </auro-input>
        </div>

        <div className="closed-form-input">
          <auro-input activeLabel="true" disabled="true" bordered value="N/A">
            <span className="label" slot="label">
              ETR Time
            </span>
          </auro-input>
        </div>

        <div className="closed-form-input">
          <auro-input
            disabled="true"
            data-testid="ata-code"
            required
            activeLabel="true"
            bordered
            value={onEditOts?.ATACode}
          >
            <span className="label" slot="label">
              ATA
            </span>
          </auro-input>
        </div>
        <div className="closed-date-form-input">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="OTS start time"
              ampm={false}
              format="HH:mm MM/dd/yyyy"
              timeSteps={{ minutes: 15 }}
              value={otstime}
              onChange={handleOtsTimeChange}
              onError={handleInvalidOtsDate}
              sx={{ width: "100%" }}
            />
            {isErrorOts && (
              <div className="dateTimeError">Enter a valid OTS Time</div>
            )}
            {isStartAfterClosed && (
              <div className="dateTimeError">
                OTS start time is after OTS closed time
              </div>
            )}
          </LocalizationProvider>
        </div>
        <div className="closed-date-form-input">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="OTS close time"
              ampm={false}
              format="HH:mm MM/dd/yyyy"
              timeSteps={{ minutes: 15 }}
              value={closedTime}
              onChange={handleOtsCloseTimeChange}
              onError={handleInvalidOtsClosedDate}
              sx={{ width: "100%" }}
            />
            {isErrorOtsClosed && (
              <div className="dateTimeError">Enter a valid OTS closed time</div>
            )}
            {isClosedBeforeOtsStart && (
              <div className="dateTimeError">
                OTS closed time is before OTS start time
              </div>
            )}
          </LocalizationProvider>
        </div>
      </div>

      <div className="problem-container-modal">
        <auro-input
          disabled="true"
          data-testid="problem-statement"
          className="problem-statemnent"
          required
          validateOnInput
          activeLabel="true"
          bordered
          maxlength="200"
          value={onEditOts?.ProblemText}
        >
          <span className="label" slot="label">
            Problem Statement
          </span>
        </auro-input>
      </div>
    </span>
    <ReopenModal isModalOpen={showReopenModal} isValidComment={isValidComment} aircraftRegistration={onEditOts?.AircraftRegistration} close={handleModalClose} confirm={handleModalConfirm} messageChange={handleMessage} />
    </React.Fragment>
  );
}
